import { readable, derived } from 'svelte/store';

const baseIframeMessage = { sender: 'yinzcam-janus', target: 'yinzcam-sdk' };

export function checkFunctionAvailable(functionName) {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[functionName]) {
    return true;
  } else if (window.YinzNativeApplication && window.YinzNativeApplication[functionName]) {
    return true;
  } else if (CONFIG.enableIframeIntegration) {
    return true;
  }
  return false;
}

export function ycDismissWebView() {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycDismissWebView) {
    console.log('CALLING: window.webkit.messageHandlers.ycDismissWebView.postMessage({})');
    window.webkit.messageHandlers.ycDismissWebView.postMessage({});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycDismissWebView) {
    console.log('CALLING: window.YinzNativeApplication.ycDismissWebView()');
    window.YinzNativeApplication.ycDismissWebView();
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycDismissWebView'})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycDismissWebView'}, '*');
  } else {
    console.log('Unable to call ycDismissWebView: no message handler found.')
  }
}

export function ycOnboardingTriggerLocation() {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycOnboardingTriggerLocation) {
    console.log('CALLING: window.webkit.messageHandlers.ycOnboardingTriggerLocation.postMessage({})');
    window.webkit.messageHandlers.ycOnboardingTriggerLocation.postMessage({});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycOnboardingTriggerLocation) {
    console.log('CALLING: window.YinzNativeApplication.ycOnboardingTriggerLocation()');
    window.YinzNativeApplication.ycOnboardingTriggerLocation();
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycOnboardingTriggerLocation'})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycOnboardingTriggerLocation'}, '*');
  } else {
    console.error('Unable to call ycOnboardingTriggerLocation: no message handler found.')
  }
}

export function ycOnboardingTriggerNotification(tags) {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycOnboardingTriggerNotification) {
    console.log('CALLING: window.webkit.messageHandlers.ycOnboardingTriggerNotification.postMessage({tags: tags})');
    window.webkit.messageHandlers.ycOnboardingTriggerNotification.postMessage({tags: tags});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycOnboardingTriggerNotification) {
    console.log('window.YinzNativeApplication.ycOnboardingTriggerNotification(tags)');
    window.YinzNativeApplication.ycOnboardingTriggerNotification(tags);
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycOnboardingTriggerNotification', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycOnboardingTriggerNotification', tags}, '*');
  } else {
    console.error('Unable to call ycOnboardingTriggerNotification: no message handler found.')
  }
}

export function ycOnboardingTriggerMicrophone() {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycOnboardingTriggerMicrophone) {
    console.log('CALLING: window.webkit.messageHandlers.ycOnboardingTriggerMicrophone.postMessage({})');
    window.webkit.messageHandlers.ycOnboardingTriggerMicrophone.postMessage({});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycOnboardingTriggerMicrophone) {
    console.log('CALLING: window.YinzNativeApplication.ycOnboardingTriggerMicrophone()');
    window.YinzNativeApplication.ycOnboardingTriggerMicrophone();
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycOnboardingTriggerMicrophone'})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycOnboardingTriggerMicrophone'}, '*');
  } else {
    console.error('Unable to call ycOnboardingTriggerMicrophone: no message handler found.')
  }
}

export function ycSSOThirdParty(type) {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycSSOThirdParty) {
    window.webkit.messageHandlers.ycSSOThirdParty.postMessage({type: type});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycSSOThirdParty) {
    window.YinzNativeApplication.ycSSOThirdParty(type);
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycSSOThirdParty', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycSSOThirdParty', type}, '*');
  } else {
    console.error('Unable to call ycSSOThirdParty: no message handler found.')
  }
}

export function ycSSOStoreTicket(yinzID, accountCreated, yticket, yvalidSpan) {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycSSOStoreTicket) {
    window.webkit.messageHandlers.ycSSOStoreTicket.postMessage({yinzID: yinzID, accountCreated: accountCreated, yticket: yticket, yvalidSpan: yvalidSpan, lvalidSpanString: null, ltoken: null});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycSSOStoreTicket) {
    window.YinzNativeApplication.ycSSOStoreTicket(yinzID, accountCreated, yticket, yvalidSpan, null, null);
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycSSOStoreTicket', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycLaunchRycSSOStoreTicketedirect', yinzID, accountCreated, yticket, yvalidSpan}, '*');
  } else {
    console.error('Unable to call ycSSOStoreTicket: no message handler found.')
  }
}

export function ycSSOAuthFinished(success) {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycSSOAuthFinished) {
    window.webkit.messageHandlers.ycSSOAuthFinished.postMessage({success: success});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycSSOStoreTicket) {
    window.YinzNativeApplication.ycSSOAuthFinished(success);
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycSSOAuthFinished', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycSSOAuthFinished', success}, '*');
  } else {
    console.error('Unable to call ycSSOAuthFinished: no message handler found.')
  }
}

export function ycSSOSetState(accountCreated, yinzId, validSpan, ticket) {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycSSOSetState) {
    console.log(`CALLING: window.webkit.messageHandlers.ycSSOSetState.postMessage({accountCreated: ${accountCreated}, yinzID: ${yinzId}, yvalidSpan: ${validSpan}, yticket: ${ticket}})`);
    window.webkit.messageHandlers.ycSSOSetState.postMessage({accountCreated, yinzID: yinzId, yvalidSpan: validSpan, yticket: ticket});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycSSOSetState) {
    console.log(`CALLING: window.YinzNativeApplication.ycSSOSetState(${accountCreated}, ${yinzId}, ${validSpan}, ${ticket})`);
    window.YinzNativeApplication.ycSSOSetState(accountCreated, yinzId, validSpan, ticket);
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycSSOSetState', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycSSOSetState', accountCreated, yinzId, validSpan, ticket}, '*');
  } else {
    console.error('Unable to call ycSSOSetState: no message handler found.');
  }
}

export async function ycSSOGetCapabilities() {
  let ret = null;
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycSSOGetCapabilities) {
    console.log(`CALLING: window.webkit.messageHandlers.ycSSOGetCapabilities.postMessage({})`);
    ret = await window.webkit.messageHandlers.ycSSOGetCapabilities.postMessage({});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycSSOGetCapabilities) {
    console.log(`CALLING: window.YinzNativeApplication.ycSSOGetCapabilities()`);
    ret = window.YinzNativeApplication.ycSSOGetCapabilities();
    ret = JSON.parse(ret);
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycSSOGetCapabilities'})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycSSOGetCapabilities'}, '*');
  } else {
    console.log('Unable to call ycSSOGetCapabilities: no message handler found.');
    return {};
  }
  //alert(`ycSSOGetCapabilities: ycSSOThirdPartyAuthAcceptsJSONArgument=${ret.ycSSOThirdPartyAuthAcceptsJSONArgument}`);
  //alert(`ycSSOGetCapabilities: ${JSON.stringify(ret)}`);
  return ret || {};
}

let ycSSOThirdPartyAuthCallbackFunction = null;
export async function ycSSOThirdPartyAuth(method, config, cb) {
  /*if (ycSSOThirdPartyAuthCallbackFunction) {
    console.error("Unable to call ycSSOThirdPartyAuth: outstanding async call in progress");
    return;
  }*/
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycSSOThirdPartyAuth) {
    console.log(`CALLING: window.webkit.messageHandlers.ycSSOThirdPartyAuth.postMessage({method: ${method}, config: ${config}})`);
    ycSSOThirdPartyAuthCallbackFunction = cb;
    window.webkit.messageHandlers.ycSSOThirdPartyAuth.postMessage({method, config});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycSSOThirdPartyAuth) {
    ycSSOThirdPartyAuthCallbackFunction = cb;
    if ((await ycSSOGetCapabilities()).ycSSOThirdPartyAuthAcceptsJSONArgument) {
      console.log(`CALLING: window.YinzNativeApplication.ycSSOThirdPartyAuth({method: ${method}, config: ${config}})`);
      window.YinzNativeApplication.ycSSOThirdPartyAuth(JSON.stringify({method, config, ...((config.id)? { id: config.id } : {})}));
    } else {
      console.log(`CALLING: window.YinzNativeApplication.ycSSOThirdPartyAuth(${method}, ${config.androidHostKey}, ${config.hostKey}, ${config.teamDisplayName}, ${config.isAutoLogin})`);
      window.YinzNativeApplication.ycSSOThirdPartyAuth(method, config.androidHostKey, config.hostKey, config.teamDisplayName, config.isAutoLogin);
    }
  } else if (CONFIG.enableIframeIntegration) {
    ycSSOThirdPartyAuthCallbackFunction = cb;
    console.log(`CALLING: window.parent.postMessage({message: 'ycSSOThirdPartyAuth', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycSSOThirdPartyAuth', method, config}, '*');
  } else {
    console.log('Unable to call ycSSOThirdPartyAuth: no message handler found.');
  }
}

if (CONFIG.enableIframeIntegration) {
  window.addEventListener('message', async function(message) {
    if (message.data.sender !== 'yinzcam-sdk' ||
        message.data.target !== 'yinzcam-janus') {
      return;
    }
    if (message.data.message === "ycSSOThirdPartyAuthCallback") {
      const method = message.data.method;
      const result = message.data.result;
      console.log('ycSSOThirdPartyAuthCallback (via message): ' + method, result);
      if (!ycSSOThirdPartyAuthCallbackFunction) {
        console.error("ycSSOThirdPartyAuthCallback: no callback function registered?");
        return;
      }
      // important - set the function to null to prevent multiple concurrent calls during the await
      const func = ycSSOThirdPartyAuthCallbackFunction;
      ycSSOThirdPartyAuthCallbackFunction = null;
      await func(method, result);
    }
  });
}

window.ycSSOThirdPartyAuthCallback = async function(method, resultJson) {
  console.log('ycSSOThirdPartyAuthCallback: ' + method, arguments);
  let ret = '{}'; // iOS requires a string return. Made it an empty JSON object in case we want to use this in the future.
  if (!ycSSOThirdPartyAuthCallbackFunction) {
    console.error("ycSSOThirdPartyAuthCallback: no callback function registered?");
    return ret;
  }
  let result = null;
  try {
    result = JSON.parse(resultJson);
  } catch (e) {
    console.error("ycSSOThirdPartyAuthCallback: unable to parse result json", e);
    return ret;
  }
  // important - set the function to null to prevent multiple concurrent calls during the await
  const func = ycSSOThirdPartyAuthCallbackFunction;
  ycSSOThirdPartyAuthCallbackFunction = null;
  await func(method, result);
  return ret;
}

export function ycSSOEndDialog(retry, dataChanged) {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycSSOEndDialog) {
    console.log(`CALLING: window.webkit.messageHandlers.ycSSOEndDialog.postMessage({retry: ${retry}, dataChanged: ${dataChanged}})`);
    window.webkit.messageHandlers.ycSSOEndDialog.postMessage({retry, dataChanged});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycSSOEndDialog) {
    console.log(`CALLING: window.YinzNativeApplication.ycSSOEndDialog(${retry}, ${dataChanged})`);
    window.YinzNativeApplication.ycSSOEndDialog(retry, dataChanged);
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycSSOEndDialog', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycSSOEndDialog', retry, dataChanged}, '*');
  } else {
    console.error('Unable to call ycSSOEndDialog: no message handler found.');
  }
}

export function ycPreloadComplete() {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycPreloadComplete) {
    console.log(`CALLING: window.webkit.messageHandlers.ycPreloadComplete.postMessage()`);
    window.webkit.messageHandlers.ycPreloadComplete.postMessage({});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycPreloadComplete) {
    console.log(`CALLING: window.YinzNativeApplication.ycPreloadComplete()`);
    window.YinzNativeApplication.ycPreloadComplete();
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycPreloadComplete', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycPreloadComplete'}, '*');
  } else {
    console.error('Unable to call ycPreloadComplete: no message handler found.');
  }
}

export function ycLaunchRedirect(name) {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycLaunchRedirect) {
    console.log(`CALLING: window.webkit.messageHandlers.ycLaunchRedirect.postMessage()`);
    window.webkit.messageHandlers.ycLaunchRedirect.postMessage({name});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycLaunchRedirect) {
    console.log(`CALLING: window.YinzNativeApplication.ycLaunchRedirect()`);
    window.YinzNativeApplication.ycLaunchRedirect(name);
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycLaunchRedirect', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycLaunchRedirect', name}, '*');
  } else {
    console.error('Unable to call ycLaunchRedirect: no message handler found.');
  }
}

// onboarding callbacks
/*
window.ycOnboardingPermissionUpdate = function(type, value) {
  window.localStorage.setItem('yc-onboarding-permission-' + type, value);
  document.dispatchEvent(new Event('yc-onboarding-permission-' + type));
};
*/

// TODO, move this elsewhere?
window.ycSSOThirdPartyCallback = function(type, json) {
  //console.log(json);
  ycSSOAuthFinished(true);
};

export const ycTicket = readable({ticket: null, validSpan: null}, function start(set) {
  if (CONFIG.enableIframeIntegration) {
    /*
    window.addEventListener('message', function(message) {
      console.log("ycTicket: Message received from the parent: ", JSON.stringify(message.data));
      if (message.data.sender !== 'yinzcam-sdk' ||
          message.data.target !== 'yinzcam-janus') {
        return;
      }
      if (message.data.message === "setHubValidTicket") {
        set({ticket: message.data.ticket, validSpan: message.data.validSpan});
      }
    });
    // This is to tell the parent that we are ready to accept SSO credentials if the parent wants to send.
    console.log(`CALLING: window.parent.postMessage({message: 'getAppValidTicket'})`);
    window.parent.postMessage({...baseIframeMessage, message: 'getAppValidTicket'}, '*');
    */
  }

  window.setHubValidTicket = function(ticket, validSpan) {
    console.log('Set ticket callback from app', ticket, validSpan);
    if (typeof validSpan === 'string') {
      validSpan = parseInt(validSpan)
    }
    set({ticket, validSpan});
  };
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getAppValidTicket) {
    console.log('Set ticket for iOS');
    window.webkit.messageHandlers.getAppValidTicket.postMessage({});
    // for testing
    //setTimeout(() => window.setHubValidTicket('lBUzg5+WQMiHaezezUtwjQAAAXZJNC+zFSFWFOk4syTD/fnnx9Hi10DDIQ6X+qCHbN6f9femcotrfoHcey/zBxBkgYR6vT9QQfoWdvG832bU6Z6ZkbUb/rUDh71lPuhKtX6/e/+h4AKXlqzxhGjadodZQxEDhdF0', 31536000000), 500);
  } else if (typeof window.YinzNativeApplication != 'undefined') {
    console.log('Set ticket for ANDROID');
    window.YinzNativeApplication.getAppValidTicket();
  } else {
    // for testing
    //console.log('Set ticket for WEB (testing)');
    // window.setHubValidTicket('c99BiajpSzuDW232xhCMrAAAAXo+7ENN43EH9z5MIwdQFLoI8QkqEtFrqS70M9QWwksDwmcNCP/dXS/J5K+8Q5NiEMfxE85chXo6XQwrADLGCLwxcRXb4bfKGsm/8vboVURJpn69/+Mx4rSRJ4FtvU3HSyzAJJPN', 31536000000);
    //window.setHubValidTicket('+MLugCn+ShGcOmBfyTplOAAAAXwoZQK631BL9+dLxpYsUeixnWdjYTi04kRxbqWYAK9KNZOJAMdtmb+Hl9FlIbyd4jnLeX46iEfOVVynYwaAZ4Y5qqqH9S2aePD+InfEYtxBfVqXBKQqh9ektxNP170pxqEguhW4', 31536000000);
  }
  function stopHandler() {
    window.setHubValidTicket = () => {};
  }
  return stopHandler;
});

export function ycAnalyticsTrackCustomWithResource(type_major, type_minor, resource_major, resource_minor) {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycAnalyticsTrackCustomWithResource) {
    console.log(`CALLING: window.webkit.messageHandlers.ycAnalyticsTrackCustomWithResource.postMessage({type_major: ${type_major}, type_minor: ${type_minor}, resource_major: ${resource_major}, resource_minor: ${resource_minor}})`);
    window.webkit.messageHandlers.yinzWebAnalytics.postMessage({type_major, type_minor, resource_major, resource_minor});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycAnalyticsTrackCustomWithResource) {
    console.log(`CALLING: window.YinzNativeApplication.ycAnalyticsTrackCustomWithResource({type_major: ${type_major}, type_minor: ${type_minor}, resource_major: ${resource_major}, resource_minor: ${resource_minor}})`);
    YinzNativeApplication.ycAnalyticsTrackCustomWithResource(type_major, type_minor, resource_major, resource_minor);
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycAnalyticsTrackCustomWithResource', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycAnalyticsTrackCustomWithResource', type_major, type_minor, resource_major, resource_minor}, '*');
  }
}

export function ycAnalyticsTrackMParticle(triggerType, eventName, eventType, attributes) {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycAnalyticsTrackMParticle) {
    console.log(`CALLING: window.webkit.messageHandlers.ycAnalyticsTrackMParticle.postMessage({triggerType: ${triggerType}, eventName: ${eventName}, eventType: ${eventType}, attributes: ${attributes}})`);
    //alert(`CALLING: window.webkit.messageHandlers.ycAnalyticsTrackMParticle.postMessage({triggerType: ${triggerType}, eventName: ${eventName}, eventType: ${eventType}, attributes: ${attributes}})`);
    window.webkit.messageHandlers.ycAnalyticsTrackMParticle.postMessage({triggerType, eventName, eventType, attributes});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycAnalyticsTrackMParticle) {
    console.log(`CALLING: window.YinzNativeApplication.ycAnalyticsTrackMParticle({triggerType: ${triggerType}, eventName: ${eventName}, eventType: ${eventType}, attributes: ${attributes}})`);
    window.YinzNativeApplication.ycAnalyticsTrackMParticle(JSON.stringify({triggerType, eventName, eventType, attributes}));
    //alert('called ycAnalyticsTrackMParticle');
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycAnalyticsTrackMParticle', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycAnalyticsTrackMParticle', triggerType, eventName, eventType, attributes}, '*');
  } else {
    //alert('failed to call ycAnalyticsTrackMParticle');
    console.log('Unable to call ycAnalyticsTrackMParticle: no message handler found.');
  }
}

/*
{
  name: 'CookieNameHere',
  value: 'CookieValueHere',
  domain: '.nba.com', // can be any domain prefix
  path: '/', // can be any path prefix
  secure: true,
  httpOnly: true,
  sameSite: 'Lax', // can be 'None', 'Lax', 'Strict',
  maxAge: 9999, // number of seconds until automatic expiration
}
*/
export function ycSetCookie(name, value, domain, maxAge, path = '/', secure = true, httpOnly = true, sameSite = 'Lax') {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycSetCookie) {
    console.log(`CALLING: window.webkit.messageHandlers.ycSetCookie.postMessage({name: ${name}, value: ${value}, domain: ${domain}, maxAge: ${maxAge}, path: ${path}, secure: ${secure}, httpOnly: ${httpOnly}, sameSite: ${sameSite}})`);
    window.webkit.messageHandlers.ycSetCookie.postMessage({name, value, domain, maxAge, path, secure, httpOnly, sameSite});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycSetCookie) {
    console.log(`CALLING: window.YinzNativeApplication.ycSetCookie({name: ${name}, value: ${value}, domain: ${domain}, maxAge: ${maxAge}, path: ${path}, secure: ${secure}, httpOnly: ${httpOnly}, sameSite: ${sameSite}})`);
    window.YinzNativeApplication.ycSetCookie(JSON.stringify({name, value, domain, maxAge, path, secure, httpOnly, sameSite}));
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycSetCookie', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycSetCookie', name, value, domain, maxAge, path, secure, httpOnly, sameSite}, '*');
  } else {
    console.log('Unable to call ycSetCookie: no message handler found.');
  }
}

export function ycRedirectWithHeaders(url, headers = {}) {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycRedirectWithHeaders) {
    console.log(`CALLING: window.webkit.messageHandlers.ycRedirectWithHeaders.postMessage({url: ${url}, headers: ${headers})`);
    window.webkit.messageHandlers.ycRedirectWithHeaders.postMessage({url, headers});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycRedirectWithHeaders) {
    console.log(`CALLING: window.YinzNativeApplication.ycRedirectWithHeaders({url: ${url}, headers: ${headers}})`);
    window.YinzNativeApplication.ycRedirectWithHeaders(JSON.stringify({url, headers}));
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'ycRedirectWithHeaders', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'ycRedirectWithHeaders', url, headers}, '*');
  } else {
    console.log('Unable to call ycRedirectWithHeaders: no message handler found.');
  }
}


export function ycNativeAlert(title, message) {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeAlert) {
    console.log(`CALLING: window.webkit.messageHandlers.nativeAlert.postMessage({title: ${title},{message: ${message}})`);
    window.webkit.messageHandlers.nativeAlert.postMessage({title, message});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.nativeAlert) {
    console.log(`CALLING: window.YinzNativeApplication.nativeAlert.postMessage({title: ${title},{message: ${message}})`);
    window.YinzNativeApplication.nativeAlert(title,message);
  } else if (CONFIG.enableIframeIntegration) {
    console.log(`CALLING: window.parent.postMessage({message: 'nativeAlert', ...})`);
    window.parent.postMessage({...baseIframeMessage, message: 'nativeAlert', title, message}, '*');
  } else {
    console.log('Unable to call nativeAlert: no message handler found. Showing default Javascript alert.');
    alert(message);
  }
}

window.ycapp = {
  checkFunctionAvailable,
  ycDismissWebView,
  ycOnboardingTriggerLocation,
  ycOnboardingTriggerNotification,
  ycOnboardingTriggerMicrophone,
  ycSSOThirdParty,
  ycSSOStoreTicket,
  ycSSOAuthFinished,
  ycSSOSetState,
  ycSSOGetCapabilities,
  ycSSOThirdPartyAuth,
  ycSSOEndDialog,
  ycPreloadComplete,
  ycLaunchRedirect,
  ycAnalyticsTrackCustomWithResource,
  ycAnalyticsTrackMParticle,
  ycNativeAlert
};
